import { render, staticRenderFns } from "./Vsidentify.vue?vue&type=template&id=38f10328"
import script from "./Vsidentify.vue?vue&type=script&lang=js"
export * from "./Vsidentify.vue?vue&type=script&lang=js"
import style0 from "./Vsidentify.vue?vue&type=style&index=0&id=38f10328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports